import { IConfig } from "./configTypes";

export const config: IConfig = {
	mode: (import.meta as any).env.MODE || "production",
	themeName: (import.meta as any).env.VITE_THEME_NAME || "dgs",
	uploadedFileMaxSize: (import.meta as any).env.VITE_UPLOADED_FILE_MAX_SIZE || 6,
};
